// Customer-specific API calls
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

/**
 * Get customer profile
 */
export async function getCustomerProfile() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/profile`,
  });
  return response.data;
}

/**
 * Get customer's debits
 */
export async function getCustomerDebits(pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE, status: string = 'ACTIVE') {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/debits?page=${pageNumber}&size=${pageSize}&status=${status}`,
  });
  return response.data;
}

/**
 * Get customer's total outstanding
 */
export async function getCustomerOutstanding() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/outstanding`,
  });
  return response.data;
}

/**
 * Get customer's payment history
 */
export async function getCustomerPayments(pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/payments?page=${pageNumber}&size=${pageSize}`,
  });
  return response.data;
}

/**
 * Customer's own deposits (paginated). Response data includes result, totalCount, totalActiveAmount.
 */
export async function getCustomerDeposits(pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/customer/deposits?page=${pageNumber}&size=${pageSize}`,
  });
  return response.data;
}
